angular.module('ui.order.orderDetailed', [])

    .directive('orderDetailed', function () {
        return {
            restrict: "E",
            templateUrl: 'app/ui/order/orderDetailedView/orderDetailed/orderDetailed.html',
            scope: {
                orderId: "=",
                orderItemId: "="
            },
            controller: 'OrderDetailedController',
            controllerAs: 'OrderDetailedController'
        };
    })

    .controller('OrderDetailedController', function ($scope, $q, $log, toastr, gettextCatalog, serverLocalization, uiLocalization,
                                                     $customisationConfig, orderDetailedControllerUpdatesService,
                                                     orderItemsRepository, ordersRepository, usersRepository, workflowRepository) {
        var currentUser;
        var steps;

        $scope.selectOrderItem = selectOrderItem;

        initController();

        function initController() {
            initData();
            initWatchers();
        }

        function initWatchers() {
            orderDetailedControllerUpdatesService.onOrderItemChanged(function (modelInfo) {
                if ($scope.orderItems && _.any($scope.orderItems, function (oi) {
                        return oi.getId() == modelInfo.id;
                    })) {
                    initList();
                }
            });
            orderDetailedControllerUpdatesService.onOrderChanged(function (modelInfo) {
                if ($scope.orderId && modelInfo.id === $scope.orderId) {
                    initList();
                }
            });
            orderDetailedControllerUpdatesService.onNewOrderItem(function () {
                initList();
            });
        }

        function onOrderItemActionExecute() {
            initData();
        }

        function initData() {
            if ($scope.orderId) {

                initList();

            } else if ($scope.orderItemId) {
                $scope.isDataLoaded = false;
                orderItemsRepository.getOrderItem($scope.orderItemId)
                    .then(function (oi) {
                        $scope.orderItem = oi;
                        $scope.orderItemId = oi.getId();
                        $scope.orderId = oi.$model.orderId;
                        $scope.order = oi.$model.order;
                        initList();
                    }, function (err) {
                        $scope.isDataLoaded = true;
                        $log.error("Can't load orderItem: `%s`. Cause: %s", $scope.orderItemId, err.message);
                        $scope.orderItem = null;
                        $scope.orderItemId = null;
                        toastr.error(err.message, gettextCatalog.getString("Can't load order item"));
                    });

            } else {

                toastr.warning(gettextCatalog.getString("Order was not specified"));
                $state.go('client.orders');

            }
        }

        function initList() {
            if (!$scope.orderId) {
                return;
            }
            $scope.isDataLoaded = false;
            ordersRepository.getOrderItemsForOrder($scope.orderId)
                .then(function (ois) {
                    $scope.isDataLoaded = true;
                    $scope.orderItems = ois;
                    if ($scope.orderItemId) {
                        $scope.orderItem = _.find($scope.orderItems, function (oi) {
                            return oi.getId() == $scope.orderItemId;
                        });
                        $scope.orderItemId = $scope.orderItem ? $scope.orderItem.getId() : null;
                    }
                    initStepHeader();
                },
                function (err) {
                    $scope.isDataLoaded = true;
                    $log.error("Can't load list of orderItems for order: `%s`. Cause: %s", $scope.orderId, err.message);
                    toastr.error(err.message, gettextCatalog.getString("Can't load list of order items"));
                });
        }

        /**
         * Method to collect/construct data necessary to render corresponding step icon/button in the header of the nav bar
         */
        function initStepHeader() {
            $scope.stateDisplayName = "";
            $scope.stateIconName = "";

            if (!currentUser || !steps) {
                $q.all([
                    usersRepository.getCurrentUser(),
                    workflowRepository.getSteps()
                ]).then(function (data) {
                    currentUser = data[0];
                    steps = data[1];
                    initStepHeaderInternal();
                });
            } else {
                initStepHeaderInternal();
            }
        }

        function initStepHeaderInternal() {
            if (!$scope.orderItem) {
                return;
            }

            var oiStep = $scope.orderItem.$model.stepCode;
            var stepDisplayName = "All Items";
            var isCustomer = currentUser.isCustomer();
            var step = _.find(steps, function (s) {
                return s.$model.code === oiStep;
            });
            var stepConfig = _.find($customisationConfig.workflow.steps, function (s) {
                return s.code === oiStep;
            });

            if (step) {
                stepDisplayName = isCustomer ? step.$model.publicNameResource : step.$model.nameResource;
            }

            var fallbackIconForStep = function (stepCode) {
                return $customisationConfig.hasResource(function (res) {
                    return _.string.contains(res, stepCode + ".");
                }) ? stepCode : "workflow";
            };

            if ($scope.step && $scope.step !== "all-open") {
                $scope.stateDisplayName = serverLocalization.translate(stepDisplayName);
            } else {
                $scope.stateDisplayName = gettextCatalog.getString("All Items");
            }
            $scope.stateIconName =
                !stepConfig
                    ? fallbackIconForStep(oiStep)
                    : (
                    (!!stepConfig.publicImageResourceName && isCustomer)
                        ? stepConfig.publicImageResourceName
                        : (!!stepConfig.imageResourceName ? stepConfig.imageResourceName : fallbackIconForStep(oiStep))
                );
        }

        function selectOrderItem(oi) {
            $scope.orderItem = oi;
            if ($scope.orderItem) {
                $scope.orderItemId = $scope.orderItem.getId();
            }
            initStepHeader();
        }

    })

    // Separate service for update events (to prevent multiple event subscription)
    .service('orderDetailedControllerUpdatesService', function (rest) {
        var _this = this;
        var newOrderItemCb;
        var orderItemChangedCb;
        var orderChangedCb;

        rest.events.on("modelCreatedOnServer", function (modelInfo) {
            if (!newOrderItemCb) {
                return;
            }
            if (modelInfo && modelInfo.modelType == "OrderItemModel") {
                newOrderItemCb(modelInfo);
            }
        });

        rest.events.on("modelUpdatedOnServer", function (modelInfo) {
            if (modelInfo.modelType == "OrderItemModel" && orderItemChangedCb) {
                orderItemChangedCb(modelInfo);
            } else if (modelInfo.modelType == "OrderModel" && orderChangedCb) {
                orderChangedCb(modelInfo);
            }
        });

        _this.onNewOrderItem = function (cb) {
            newOrderItemCb = cb;
        };

        _this.onOrderItemChanged = function (cb) {
            orderItemChangedCb = cb;
        };

        _this.onOrderChanged = function (cb) {
            orderChangedCb = cb;
        };

        return _this;
    })

;